





import { Vue } from 'vue-property-decorator';
export default class PrivacyPolicy extends Vue {}
